<template>
  <b-modal
    id="modal-scrollable"
    v-model="$store.state.someVariables.showSemanasTesoreria"
    scrollable
    no-close-on-backdrop
    size="lg"
    title="Detalle Semanal"
    cancel-variant="outline-secondary"
  >
    <b-list-group>
      <b-list-group-item button v-for="item in listSemanas" :key="item.id">
        <span class="ml-1" style="text-transform: capitalize; font-size:12px;"
          ><b>Semana: {{ item.semana }} </b>{{ item.fecha_inicial }} al
          {{ item.fecha_final }}</span
        >
        <b-badge style="float:right;" variant="danger" class="ml-1">
          {{ item.semana_por_pagar }} $
        </b-badge>
        <b-badge style="float:right;" variant="success">
          {{ item.semana_pagado }} $
        </b-badge>
      </b-list-group-item>
    </b-list-group>
    <template #modal-footer>
      <div style="justify-content:start; width:100%">
        <b-row>
          <b-col md="6" class="d-flex justify-content-center">
            <b-badge variant="success" class="badge-glow total">
              Pagado: {{ totalPagado }}$
            </b-badge>
          </b-col>
          <b-col md="6" class="d-flex justify-content-center">
            <b-badge variant="danger" class="badge-glow total">
              Por pagar: {{ totalPendiente }}$
            </b-badge>
          </b-col>
        </b-row>
      </div>
    </template>
  </b-modal>
</template>
<script>
import {
  BRow,
  BCol,
  BBadge,
  // BButton,
  BListGroup,
  BListGroupItem,
  // BSpinner,
  //   xxx ,
} from 'bootstrap-vue'
import { computed } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
// import {
//   URL,
//   USER,
//   ROLES,
//   // xxx,
// } from '../../utils/variables'
// import apiCall from '../../utils/apiCall'

export default {
  components: {
    BRow,
    BCol,
    BBadge,
    // BButton,
    BListGroup,
    BListGroupItem,
    // BSpinner,
  },
  directives: {
    Ripple,
  },
  props: {
    listSemanas: Array,
  },
  setup(props) {
    // const { postApi } = apiCall()
    function onlyClose() {
      store.commit('someVariables/UPDATE_SHOW_SEMANA_TESORERIA', false)
    }
    const totalPendiente = computed(() => {
      let total = 0
      props.listSemanas.forEach(element => {
        total += Number(element.semana_por_pagar)
      })
      return total.toFixed(2)
    })
    const totalPagado = computed(() => {
      let total = 0
      props.listSemanas.forEach(element => {
        total += Number(element.semana_pagado)
      })
      return total.toFixed(2)
    })
    return {
      onlyClose,
      totalPendiente,
      totalPagado,
    }
  },
}
</script>
<style>
.total {
  font-size: 14px !important;
}
</style>
